import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import "../../../dashboard/style/taskstyle.css";
import * as stageStatusHelper from '../../../../infrastructure/stagestatushelper';
import * as appUtilityFunction from '../../../../infrastructure/apputilityfunctions'
import * as constants from '../../constants';
import sharedGlobals from "../../../../sharedglobals";

export default function TaskManagementTable({ dashboardId }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dashboardData = useSelector(
        state => state.dashboardReducer.userDashboard.userdashboardData
    );
    const [searchQuery, setSearchQuery] = useState("");

    if (dashboardData === null) {
        return <div />;
    }

    const datas = dashboardData[dashboardId];
    const dataRows = datas.dataRows;

    if (dataRows.length === 0) {
        return <div />;
    }

    const getFieldNames = () => {
        const fieldNames = dataRows.reduce((uniqueNames, item) => {
            item.fields.forEach(field => {
                if (!uniqueNames.includes(field.fieldName)) {
                    uniqueNames.push(field.fieldName);
                }
            });
            return uniqueNames;
        }, []);
        return fieldNames;
    };

    /* const getFieldValue = (item, fieldName) => {
         const field = item.fields.find(field => field.fieldName === fieldName);
         return field ? field.fieldValue : '';
       };
       */
    const getFieldValue = (item, fieldName) => {
        const field = item.fields.find(field => field.fieldName === fieldName);
        if (field && appUtilityFunction.isDate(field.fieldValue)) {
            return appUtilityFunction.formatDate(field.fieldValue);
        }
        return field ? field.fieldValue : '';
    };

    const filteredDataRows = dataRows.filter(item => {
        return getFieldNames().some(fieldName => {
            const fieldValue = getFieldValue(item, fieldName);
            return fieldValue && fieldValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
        });
    });

    const onNavigate = (url) => {
        const trimmedUrl = url.substring(url.indexOf("/"));
        const crmUrl = sharedGlobals.appUrls.crmCoreUrl.replace(/\/+$/, '');
        const fullUrl = `${crmUrl}${trimmedUrl}`;
        window.location.href = fullUrl;
    }


    return (
        <div className="col-xl-12" key={dashboardId}>
            <div className="card">
                <div className="card-body py-0" data-simplebar data-simplebar-primary style={{ 'max-height': '500px' }}>
                    <div className="d-flex align-items-center justify-content-between alert alert-primary" role="alert">
                        <h4> <i className='mdi mdi-clipboard-flow-outline'></i> {datas.dashboardTitle} </h4>
                        <input
                            type="text"
                            className="form-control w-25"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

                    <table className="table table-bordered table-centered mb-0">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                {getFieldNames().map(fieldName => (
                                    fieldName == 'LINKURL' ? '' :
                                        <th key={fieldName}>{fieldName}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredDataRows.length > 0 ?
                                filteredDataRows.map((item, index) => {
                                    const createdDateStr = getFieldValue(item, 'CREATEDDT');
                                    const createdDate = new Date(createdDateStr);
                                    createdDate.setHours(0, 0, 0, 0);

                                    const statusStr = getFieldValue(item, 'STATUS')

                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);

                                    const yesterday = new Date(today);
                                    yesterday.setDate(today.getDate() - 1);

                                    const dayBeforeYesterday = new Date(today);
                                    dayBeforeYesterday.setDate(today.getDate() - 2);

                                    let rowClass = '';
                                    if (statusStr == "Closed") {
                                        rowClass = 'table-success';
                                    }
                                    else if (createdDate <= dayBeforeYesterday) {
                                        rowClass = 'table-danger';
                                    }
                                    else if (createdDate.getTime() === yesterday.getTime()) {
                                        rowClass = 'table-warning';
                                    }

                                    return (
                                        <tr key={index} className={rowClass}>
                                            <td>{index + 1}</td>
                                            {getFieldNames().map(fieldName => (
                                                fieldName === 'LINKURL' ? '' :
                                                    <td key={`${fieldName}-${index}`}>
                                                        {fieldName === 'STAGE' ? (
                                                            <span className={appUtilityFunction.getStatusBadge(getFieldValue(item, fieldName))}>
                                                                {String(getFieldValue(item, fieldName))}
                                                            </span>
                                                        ) : fieldName === 'TASKPRIORITY' ? (
                                                            <span
                                                                className={stageStatusHelper.getCRMStatusPriorityClassName(getFieldValue(item, fieldName))}
                                                                title={stageStatusHelper.getCRMStatusPriorityLabel(getFieldValue(item, fieldName))}
                                                                style={{ minWidth: '90px', fontSize: '12px', display: 'inline-block' }}
                                                            >
                                                                {stageStatusHelper.getCRMStatusPriorityLabel(getFieldValue(item, fieldName))}
                                                            </span>
                                                        ) : fieldName === 'QUOTENO' || fieldName === 'POLICYNO' || fieldName === 'REQUESTNUMBER' ?
                                                            <a
                                                                style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                                                                onClick={() => onNavigate(
                                                                    String(getFieldValue(item, 'LINKURL')),
                                                                    String(getFieldValue(item, fieldName))
                                                                )}
                                                            >
                                                                {String(getFieldValue(item, fieldName))}
                                                            </a>
                                                            : (
                                                                String(getFieldValue(item, fieldName))
                                                            )}
                                                    </td>
                                            ))}
                                        </tr>
                                    );
                                }) : <tr><td colSpan={getFieldNames().length + 1}>No results found</td></tr>
                            }

                        </tbody>
                        {/* <tbody>
                            {dataRows.length > 0 &&
                                dataRows.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        {getFieldNames().map(fieldName => (
                                            <td key={`${fieldName}-${index}`}>
                                                {fieldName === 'STAGE' ? (
                                                    <span className={appUtilityFunction.getStatusBadge(getFieldValue(item, fieldName))}>
                                                        {String(getFieldValue(item, fieldName))}
                                                    </span>
                                                ) : (
                                                    String(getFieldValue(item, fieldName))
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                        </tbody> */}
                    </table>
                </div>
            </div>
        </div>
    );
}